import React from "react";

import { Button } from "antd";

import "./FilterButton.css";

export default class FilterButton extends React.Component {
  parseFilter = () => {
    const { handleFilterToggle, filterText, filterValue } = this.props;

    if (filterValue !== undefined) {
      handleFilterToggle(filterValue);
      return;
    }

    let parsedText = filterText.split(" ")[1];

    if (parsedText === "Added") {
      parsedText = "Added";
    } else {
      parsedText = "Pending";
    }
    handleFilterToggle(parsedText.toLowerCase());
  }

  render() {
    const {
      isActive,
      filterText,
      disable,
      icon,
      alt,
      filterValue,
    } = this.props;
    let parsedType;
    if (filterValue !== undefined) {
      parsedType = filterValue || "all";
    } else {
      parsedType = filterText.includes("Added") ? "added" : "pending";
    }
    const className = `productReportSpecManagerFilterButton productReportSpecManagerFilterButton--${parsedType}${isActive ? " productReportSpecManagerFilterButton--active" : ""}`;

    return (
      <Button
        type="text"
        disabled={disable}
        className={className}
        onClick={this.parseFilter}
      >
        <div className="specManagerFilterTile">
          {icon ? (
            <img src={icon} alt={alt || ""} className="specManagerFilterButtonIcon" />
          ) : null}
          <div className="specManagerFilterText">{filterText}</div>
        </div>
      </Button>
    );
  }
}
